import React from "react";
import CalculatorCard from "./components/CalculatorCard";
import { OfferCalculatorProvider } from "./context/OfferCalculatorProvider";
import { parseBootstrap } from "./utils/parseBootstrap";
export default function App() {
    const mountNode = document.getElementById("react-offer-calculator");
    if (!mountNode) {
        return null;
    }
    const bootstrap = parseBootstrap(mountNode);
    return (<OfferCalculatorProvider bootstrap={bootstrap}>
      <CalculatorCard />
    </OfferCalculatorProvider>);
}
